import ApiClient from "@common/api/ApiClient";

class ReviewConfigurationClient extends ApiClient {
  constructor() {
    super("ReviewConfiguration");
    this.setApiUrlKey("comp_api_url");
  }

  ReadForUpdate = async () => await this.get("Update");
  Update = async (record) => await this.post("Update", record);
}

const client = new ReviewConfigurationClient();

export default client;
